import { action, makeObservable, observable } from 'mobx';
import { betStore } from '@pascal/pascal-core/shared/core/store';

import { doBetStore } from './doBetStore';

class GameStore {
  fish = { fish: null, skip: 0, odd: null };

  time = null;

  oddResultTypePair = null;

  currentReportResultData = { odd: null, resultType: null, animation: false };

  showResultAnimation = false;

  reportResult = [];

  roundStarted = false;

  currentFish = null;

  numPadData = { isOpen: false, sectionIndex: null };

  timerValue = null;

  wageringOdd = null;

  isPongReceived = false;

  currentRound = {};

  currentRoundId = null;

  gameScene = null;

  isShark = false;

  constructor() {
    makeObservable(this, {
      time: observable,
      isShark: observable,
      gameScene: observable,
      currentFish: observable,
      isPongReceived: observable,
      showResultAnimation: observable,
      roundStarted: observable,
      currentRoundId: observable,
      fish: observable.deep,
      numPadData: observable.deep,
      reportResult: observable.deep,
      currentRound: observable.deep,
      currentReportResultData: observable.deep,
      oddResultTypePair: observable.deep,
      setTime: action.bound,
      timerValue: observable,
      wageringOdd: observable,
      setGameScene: action.bound,
      setTimerValue: action.bound,
      resetCurrentFish: action.bound,
      setRoundStarted: action.bound,
      setReportResult: action.bound,
      setWageringOdd: action.bound,
      setNumPudData: action.bound,
      setCurrentFish: action.bound,
      resetGameData: action.bound,
      setIsPongReceived: action.bound,
      setOddResultTypePair: action.bound,
      setCurrentRound: action.bound,
      setIsShark: action.bound,
      setCurrentRoundId: action.bound,
      setShowResultAnimation: action.bound,
      setReportResultWithAnimation: action?.bound,
      setReportResultWithOutAnimation: action?.bound,
    });
  }

  setRoundStarted(roundStarted) {
    this.roundStarted = roundStarted;
  }

  setNumPudData(numPudData) {
    this.numPadData = numPudData;
  }

  resetGameData() {
    doBetStore.resetDoBetStore();
    this.fish = { fish: null, skip: 0, odd: null };
    this.time = null;
    this.currentReportResultData = { odd: null, resultType: null, animation: false };
    this.showResultAnimation = false;
    // this.resetReportResultAnimationState();
    this.setReportResult([]);
    this.roundStarted = false;
    this.currentFish = null;
    this.timerValue = null;
    this.wageringOdd = null;
    this.currentRound = {};
    this.currentRoundId = null;
    this.gameScene = null;
    betStore.resetBetHistory();
    betStore.setLiveBets([]);
  }

  setCurrentRound(currentRound) {
    this.currentRound = currentRound;
  }

  setGameScene(gameScene) {
    this.gameScene = gameScene;
  }

  resetCurrentFish() {
    this.currentFish = null;
  }

  setCurrentFish(data) {
    this.currentFish = data;
    if (data?.odd) {
      setTimeout(() => {
        this.resetCurrentFish();
      }, 1000);
    }
  }

  setShowResultAnimation(showResultAnimation) {
    this.showResultAnimation = showResultAnimation;
  }

  setReportResultWithAnimation(response) {
    this.currentReportResultData = {
      odd: response?.odd,
      resultType: response?.resultType,
      animation: true,
    };
  }

  setReportResultWithOutAnimation(response) {
    this.currentReportResultData = {
      odd: response?.odd,
      resultType: response?.resultType,
      animation: false,
    };
  }

  setTimerValue(timerValue) {
    this.timerValue = timerValue;
  }

  setTime(time) {
    this.time = time;
  }

  setCurrentRoundId(currentRoundId) {
    this.currentRoundId = currentRoundId;
  }

  resetReportResultAnimationState() {
    this.reportResult = this.reportResult.map((report) =>
      this.setReportResultWithOutAnimation(report)
    );
  }

  _getPrevReportResultAndLastElement(reports) {
    const newReferenceReports = [...reports];
    if (!newReferenceReports.length) {
      return {
        last: null,
        prevReports: [],
      };
    }

    const last = newReferenceReports.shift();
    return {
      last,
      prevReports: newReferenceReports,
    };
  }

  setWageringOdd(wageringOdd) {
    this.wageringOdd = wageringOdd;
  }

  setReportResult(reportResult) {
    this.reportResult = reportResult;
  }

  setIsPongReceived(isPongReceived) {
    this.isPongReceived = isPongReceived;
  }

  setOddResultTypePair(oddResultTypePair) {
    this.oddResultTypePair = oddResultTypePair;
  }

  setIsShark(isShark) {
    this.isShark = isShark;
  }
}

export const gameStore = new GameStore();
